<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedLocation">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.LOCATION' | translate }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [required]="required"
    [disabled]="disabled"
    placeholder="{{ 'MAINTENANCES.LOCATION_PLACEHOLDER' | translate }}"
    fxFlex="90"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedLocation()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let location of locations" [value]="location.id">
      {{ location.address.formattedAddress }}
    </mat-option>
    <mat-option *ngIf="!locations.length">
      {{ 'MAINTENANCES.LOCATION_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    <span *ngIf="inputValue.hasError('required')">{{ 'MAINTENANCES.ERRORS.LOCATION_REQUIRED' | translate }}</span>
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" *ngIf="selectedLocation">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.LOCATION' | translate }}</mat-label>
  <div class="flex">
    <input type="text" matInput [value]="selectedLocation.address.formattedAddress" disabled required />
    <button
      mat-icon-button
      [disabled]="disabled"
      *ngIf="selectedLocation"
      class="my-cancel-button accent-700-fg"
      (click)="deselectLocation()"
    >
      <mat-icon class="font-size-20">cancel</mat-icon>
    </button>
  </div>
</mat-form-field>
